// Modules
import styled from 'styled-components'

export const BottomSheetWrapper = styled.div`
    padding: 24px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;

    * > {
        font-family: 'Dasa Sans', 'Montserrat', sans-serif;
    }
`
export const BottomSheetTitle = styled.h1`
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.5rem;
    letter-spacing: 0;
    color: #363636;
    margin-bottom: 0.5rem;
`
export const BottomSheetContent = styled.div`
    width: 100%;
    flex: 1 0;
    overflow: auto;

    p,
    li {
        color: #666;
        line-height: 1.5rem;
        margin-bottom: 1.5rem;
        font-size: 0.875rem;
    }

    ul {
        margin-left: 1.25rem;
        li {
            list-style-type: disc;
            margin: 0;
        }
    }

    h2 {
        font-size: 1rem;
        font-weight: 500;
        line-height: 1.5rem;
        letter-spacing: 0;
        color: #363636;
        margin-bottom: 0.5rem;
    }
`
export const BottomSheetButtonWrapper = styled.div`
    margin-top: auto;
`
